<div class="department-page">
  <div class="department-header">
    <app-header-style-seven></app-header-style-seven>
  </div>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Engineering Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Developing future-ready electronics and communication engineers through
            strong academic foundations, modern laboratories, innovation, industry
            exposure, and research-oriented learning.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Affiliation</span>
            <strong>Anna University</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Intake</span>
            <strong>{{ intake }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Electronics &amp; Communication Engineering, Fatima
            Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title5.jpg"
                  alt="Department of Electronics and Communication Engineering"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>
                  Broad academic, professional, research, and ethical outcomes
                  expected from graduates of the programme.
                </p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>
                  Knowledge, skills, ethics, and professional capabilities expected
                  from graduates of the programme.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>
                  Department-specific competencies developed through Electronics
                  and Communication Engineering.
                </p>
              </div>

              <div class="outcome-grid">
                <article
                  class="outcome-card"
                  *ngFor="let item of programSpecificOutcomes"
                >
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
          <ng-container *ngSwitchCase="'tab14'">
            <section class="content-card">
              <div class="section-head">
                <h3>Programmes Offered</h3>
                <p>Current academic programme details under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Programme Name</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let programme of programmes">
                      <td>{{ programme.sno }}</td>
                      <td>{{ programme.name }}</td>
                      <td>{{ programme.duration }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Laboratory Facilities -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>
                  Modern laboratories supporting practical learning in electronics,
                  communication, embedded systems, VLSI, and related domains.
                </p>
              </div>

              <ng-container *ngIf="labs.length > 0; else noLabData">
                <div class="lab-grid">
                  <article class="lab-card" *ngFor="let lab of labs">
                    <div class="lab-media">
                      <img [src]="lab.image" [alt]="lab.title" />
                    </div>

                    <div class="lab-body">
                      <h4>{{ lab.title }}</h4>
                      <p>{{ lab.description }}</p>

                      <div class="equipment-note" *ngIf="lab.equipment">
                        <strong>Equipment:</strong> {{ lab.equipment }}
                      </div>
                    </div>
                  </article>
                </div>
              </ng-container>

              <ng-template #noLabData>
                <div class="section-copy">
                  <p>
                    Laboratory facility details will be updated soon.
                  </p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Association & Club Activities -->
      <ng-container *ngSwitchCase="'tab6'">
  <section class="content-card">
    <div class="section-head">
      <h3>Association &amp; Club Activities</h3>
      <p>
        Department association and club activities for the academic period
        {{ clubAcademicYear }}.
      </p>
    </div>

    <div class="fact-grid">
      <article class="fact-card">
        <span class="fact-title">Department</span>
        <p>{{ departmentName }}</p>
      </article>

      <article class="fact-card">
        <span class="fact-title">Academic Period</span>
        <p>{{ clubAcademicYear }}</p>
      </article>

      <article class="fact-card">
        <span class="fact-title">Association / Club</span>
        <p>{{ clubNames.join(', ') }}</p>
      </article>

      <article class="fact-card">
        <span class="fact-title">Activities Count</span>
        <p>{{ clubEvents.length }}</p>
      </article>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Events Organized</h3>
      <p>Association activities conducted under the department.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Event</th>
            <th>Date</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let event of clubEvents">
            <td>{{ event.sno }}</td>
            <td>{{ event.eventName }}</td>
            <td>{{ event.date }}</td>
            <td>{{ event.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- MoUs -->
    <ng-container *ngSwitchCase="'tab7'">
  <section class="content-card">
    <div class="section-head">
      <h3>MoU's</h3>
      <p>
        Institutional collaborations supporting seminars, internships,
        in-plant training, and research initiatives.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Organization</th>
            <th>Date of Signing</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of mous">
            <td>{{ item.sno }}</td>
            <td>{{ item.organization }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.purpose }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>MoU Photos</h3>
      <p>MoU signing highlights and industry collaboration moments of the department.</p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let photo of mouPhotos; let i = index">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          <p>{{ mouPhotoNotes[i] }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- Placement Record -->
    <ng-container *ngSwitchCase="'tab8'">
  <section class="content-card">
    <div class="section-head">
      <h3>Placement Record</h3>
      <p>
        Placement details of students from the Department of Electronics &amp; Communication Engineering.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Branch</th>
            <th>Name of the Student</th>
            <th>Name of the Organization</th>
            <th>Designation</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of placements">
            <td>{{ item.sno }}</td>
            <td>{{ item.branch }}</td>
            <td>{{ item.studentName }}</td>
            <td>{{ item.organization }}</td>
            <td>{{ item.designation }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Industrial Visit -->
       <ng-container *ngSwitchCase="'tab9'">
  <section class="content-card">
    <div class="section-head">
      <h3>Industrial Visit</h3>
      <p>
        Industry exposure visits that strengthen practical understanding
        of manufacturing, engineering systems, and advanced technology.
      </p>
    </div>

    <div class="table-wrap" *ngIf="industrialVisitRecords.length > 0">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Date</th>
            <th>Industry</th>
            <th>No of Students Benefitted</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of industrialVisitRecords">
            <td>{{ item.sno }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.industry }}</td>
            <td>{{ item.studentsBenefitted }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let visit of industrialVisits">
        <div class="lab-media">
          <img [src]="visit.image" [alt]="visit.title" />
        </div>

        <div class="lab-body">
          <h4>{{ visit.title }}</h4>
          <p>{{ visit.description }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- Value Added Courses -->
     <ng-container *ngSwitchCase="'tab10'">
  <section class="content-card">
    <div class="section-head">
      <h3>Value Added Courses</h3>
      <p>
        Additional skill-oriented courses conducted for the students of the
        Department of Electronics &amp; Communication Engineering.
      </p>
    </div>

    <ng-container *ngIf="valueAddedCourses.length > 0; else noValueAddedData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Course Name</th>
              <th>Duration</th>
              <th>Company Name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let course of valueAddedCourses">
              <td>{{ course.sno }}</td>
              <td>{{ course.courseName }}</td>
              <td>{{ course.duration }}</td>
              <td>{{ course.companyName }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-head" style="margin-top: 24px;">
        <h3>Value Added Course Photos</h3>
        <p>Highlights from value added course sessions and training activities.</p>
      </div>

      <div class="lab-grid">
        <article class="lab-card" *ngFor="let photo of valueAddedCoursePhotos">
          <div class="lab-media">
            <img [src]="photo.image" [alt]="photo.alt" />
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noValueAddedData>
      <div class="section-copy">
        <p>Value added course details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- Alumni -->
  <ng-container *ngSwitchCase="'tab11'">
  <section class="content-card">
    <div class="section-head">
      <h3>Alumni</h3>
      <p>
        Distinguished alumni of the Department of Electronics &amp; Communication
        Engineering.
      </p>
    </div>

    <ng-container *ngIf="alumniRecords.length > 0; else noAlumniData">
      <div class="alumni-grid">
        <article class="alumni-card" *ngFor="let alumni of alumniRecords">
          <div class="alumni-image-wrap">
            <img [src]="alumni.image" [alt]="alumni.alt" class="alumni-image" />
          </div>

          <div class="alumni-body">
            <h4>{{ alumni.name }}</h4>
            <p><strong>Batch:</strong> {{ alumni.batch }}</p>
            <p><strong>Designation:</strong> {{ alumni.designation }}</p>
            <p><strong>Organization:</strong> {{ alumni.organization }}</p>
            <p *ngIf="alumni.location">
              <strong>Location / Sector:</strong> {{ alumni.location }}
            </p>
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noAlumniData>
      <div class="section-copy">
        <p>Alumni details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- Achievements -->
   <ng-container *ngSwitchCase="'tab12'">
  <section class="content-card">
    <div class="section-head">
      <h3>Achievements</h3>
      <p>
        Student achievements of the Department of Electronics &amp; Communication Engineering
        in various academic, technical, cultural, and competitive events.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Branch</th>
            <th>Name of the Student</th>
            <th>Duration</th>
            <th>Name of the Event</th>
            <th>Organizing Institute</th>
            <th>Achievement</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of achievements">
            <td>{{ item.sno }}</td>
            <td>{{ item.branch }}</td>
            <td>
              <div *ngFor="let student of item.studentNames">
                {{ student }}
              </div>
            </td>
            <td>{{ item.eventDate }}</td>
            <td>{{ item.eventName }}</td>
            <td>{{ item.collegeName }}</td>
            <td>{{ item.awardName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Achievement Photos</h3>
      <p>Highlights from prize-winning student activities and competitions.</p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let photo of achievementPhotos; let i = index">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          <p>{{ achievementPhotoNotes[i] }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>
          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab13'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>
                  NPTEL course certifications completed by faculty members of the
                  Department of Electronics &amp; Communication Engineering.
                </p>
              </div>

              <ng-container *ngIf="nptelRecords.length > 0; else noNptelData">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name of the Staff</th>
                        <th>Subject</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of nptelRecords; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.staffName }}</td>
                        <td>{{ item.subject }}</td>
                        <td>{{ item.grade }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <ng-template #noNptelData>
                <div class="section-copy">
                  <p>NPTEL details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Research -->
<ng-container *ngSwitchCase="'tab15'">
  <section class="content-card">
    <div class="section-head">
      <h3>Research</h3>
      <p>
        Research scholars, publication details, and patent records of the
        Department of Electronics &amp; Communication Engineering.
      </p>
    </div>

    <div class="section-head inner-section-head">
      <h4>Research Center Data</h4>
      <p>
        Staff pursuing Ph.D. under the Department of Electronics &amp;
        Communication Engineering.
      </p>
    </div>

    <ng-container *ngIf="researchScholars.length > 0; else noResearchScholarData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Staff</th>
              <th>Name of the Domain</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of researchScholars">
              <td>{{ item.sno }}</td>
              <td>{{ item.staffName }}</td>
              <td>{{ item.domain }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noResearchScholarData>
      <div class="section-copy">
        <p>Research scholar details will be updated soon.</p>
      </div>
    </ng-template>

    <div class="section-head inner-section-head">
      <h4>Publication Details</h4>
      <p>
        Research publications contributed by faculty members of the department.
      </p>
    </div>

    <ng-container *ngIf="researchPublications.length > 0; else noPublicationData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Staff</th>
              <th>Paper Title</th>
              <th>Publication Details</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of researchPublications">
              <td>{{ item.sno }}</td>
              <td class="cell-preline">{{ item.staffName }}</td>
              <td>{{ item.paperTitle }}</td>
              <td class="cell-preline">{{ item.publicationDetails }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noPublicationData>
      <div class="section-copy">
        <p>Publication details will be updated soon.</p>
      </div>
    </ng-template>

    <div class="section-head inner-section-head">
      <h4>Patent Received</h4>
      <p>
        Patent publications and application details of faculty members.
      </p>
    </div>

    <ng-container *ngIf="patentRecords.length > 0; else noPatentData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Staff</th>
              <th>Title Of the Invention</th>
              <th>Design Number / Application Number</th>
              <th>Publication Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of patentRecords">
              <td>{{ item.sno }}</td>
              <td class="cell-preline">{{ item.staffName }}</td>
              <td>{{ item.inventionTitle }}</td>
              <td>{{ item.applicationNumber }}</td>
              <td>{{ item.publicationDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noPatentData>
      <div class="section-copy">
        <p>Patent details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>
        </ng-container>
      </main>
    </section>

    <br />

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of Department,<br />
          Department of Electronics &amp; Communication Engineering,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" [href]="'mailto:' + contactEmail">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Electronics &amp; Communication Engineering</h3>
        <p>
          Become an Electronics &amp; Communication Engineer and innovate in
          communication, embedded, and electronic systems.
        </p>
        <a
          class="apply-button"
          routerLink="/inquiry"
        >
          Apply Now
        </a>
      </article>
    </section>
  </div>
</div>